/* eslint-disable no-unused-vars */
export enum Routes {
  Root = '/',
  Contact = '/contact',
  Solutions = '/solutions',
  Overview = '/overview',
  Blog = '/blog',
  TermsOfUse = '/terms-of-use',
  PrivacyPolicy = '/privacy-policy',
  CookiePolicy = '/cookie-policy',
  Awards = '/awards',
  OrgOps = '/organization-operation',
  Games = '/games',
  Star = '/star',
  Node = '/node',
  AI = '/ai',
  Smart = '/smart',
  Dapps = '/dapps',
  About = '/about',
  Team = '/team',
  OurJourney = '/our-journey',
  WhyChoose = '/why-choose',
  Partners = '/partners',
  Swap = 'https://pioneswap.com/',
  NFT = 'https://nft.pionewallet.com/',
  Wallet = 'https://pionewallet.com/',
  Farm = 'https://pionefarm.com/',
  Care = 'https://pionecare.com/',
  House = 'https://pionehouse.com/',
  Exchange = 'https://expione.com/',
  Mart = 'https://pionemart.com/',
  Chain = 'https://pionechain.com/'
}
